import React from 'react';
import cn from 'clsx';

import Typography from '../../../../library/typography/typography';
import PitPassLogo from '../../../../components/pitpass-logo/pitpass-logo';

import { Maybe } from '../../../../shared/types/graphql-types';

import styles from './store-quick-view-header.scss';

interface StoreQuickViewHeaderProps {
  isMyStore: boolean;
  myStoreTitle?: Maybe<string>;
  showPitPassLogo: boolean;
}

function StoreQuickViewHeader(props: StoreQuickViewHeaderProps) {
  const {
    isMyStore,
    myStoreTitle = 'My Selected Store',
    showPitPassLogo
  } = props;

  if (!isMyStore) {
    return null;
  }

  return (
    <div className={styles['container']}>
      {isMyStore && (
        <Typography
          className={cn(styles['title'], 'store-quick-view-header__title')}
          tag="span"
          variant="H6"
          weight="black"
        >
          {myStoreTitle}
        </Typography>
      )}

      {showPitPassLogo && (
        <div className={styles['pitpass-logo']}>
          <PitPassLogo isPitPassLogoOnly />
        </div>
      )}
    </div>
  );
}

export default StoreQuickViewHeader;
